import React, { useEffect, useState } from "react";

const FlashSaleModal = ({ isModalVisible, setModalVisible }) => {
    useEffect(() => {
        if (isModalVisible) {
            const scrollBarWidth =
                window.innerWidth - document.documentElement.clientWidth;
            document.body.style.overflow = "hidden";
            document.body.style.paddingRight = `${scrollBarWidth}px`;
        } else {
            document.body.style.overflow = "auto";
            document.body.style.paddingRight = "0px";
        }
        return () => {
            document.body.style.overflow = "auto";
            document.body.style.paddingRight = "0px";
        };
    }, [isModalVisible]);

    const handleClose = () => {
        setModalVisible(false);
    };

    const handleOutsideClick = (e) => {
        if (e.target.classList.contains("modal")) {
            handleClose();
        }
    };

    const [countdown, setCountdown] = useState({
        hours: 0,
        minutes: 0,
        seconds: 0,
    });
    const [randomIncrease, setRandomIncrease] = useState(0);
    useEffect(() => {
        const increaseNumber = () => {
            const randomIncrease = Math.floor(Math.random() * 3) + 1;
            setRandomIncrease(randomIncrease); 
        };
        const interval = setInterval(increaseNumber, 5000);
        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        const getNextExpirationDate = (currentDate) => {
            const nextExpirationDate = new Date(currentDate);
            nextExpirationDate.setHours(24, 0, 0, 0);
            return nextExpirationDate;
        };
        const expirationDate = getNextExpirationDate(new Date(), 10);
        const callTime = expirationDate.getTime();
        const timer = setInterval(() => {
            const nowTime = new Date().getTime();
            const distance = callTime - nowTime;
            if (distance > 0) {
                const days = Math.floor(distance / (1000 * 60 * 60 * 24));
                const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                const seconds = Math.floor((distance % (1000 * 60)) / 1000);
                setCountdown({ days, hours, minutes, seconds });
            } else {
                clearInterval(timer);
            }
        }, 1000);

        return () => clearInterval(timer);
    }, []);


    return (
        <>
            {isModalVisible && (
                <div className="modal fade show" id="flashSale" role="dialog"
                    aria-labelledby="flashSaleTitle" aria-hidden="true"
                    onClick={handleOutsideClick}
                    style={{ display: "block", backgroundColor: "rgba(0, 0, 0, 0.5)" }}>
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content"
                            style={{
                                padding: '0px',
                                borderRadius: "24px", background: "#fff", height: "100%",
                                backgroundColor: "rgba(255, 255, 255, 0.37)", backdropFilter: "blur(10px)",
                            }}>
                            <div className="col-lg-12">
                                <div className="industries-box position-relative overflow-hidden">
                                    <div className="close-btn"
                                        style={{
                                            textAlign: "end", position: "absolute", right: "25px",
                                        }} >
                                        <button type="button" id="modal-close" className="close p-0 btn"
                                            onClick={handleClose} aria-label="Close">
                                            <span aria-hidden="true">
                                                <i className="at-banner__close2"></i>
                                            </span>
                                        </button>
                                    </div>

                                    <div className="industries-info text-center">
                                        <div className="card-content">
                                            <h1 className="text-white top blueNeon text-center">
                                                FLASH SALE
                                            </h1>

                                            <p className="fs-4 text-white disTwo text-center">
                                                Get 50% off all plans
                                            </p>

                                            <div className="countdown_timer" id="countdown-timer1">
                                                <span>{countdown.days} <small>Days</small> </span>{""}
                                                <span>{countdown.hours} <small>HRS</small> </span>{" "}
                                                <span>{countdown.minutes} <small>MINS</small> </span>{" "}
                                                <span>{countdown.seconds} <small>SECS</small> </span>
                                            </div>
                                        </div>
                                        <a onClick={handleClose}
                                            className="paddle_button offer-vsbtn paddle_styled_button px-10 py-3 fs-3"
                                            href="#choosePlans"
                                        >
                                            CLAIM 50% OFF NOW
                                        </a>
                                        <p className="fs-4 text-white text-center mt-5">
                                            Ready to unleash 🔥 your creativity with{" "}
                                            <strong>Hey Visuals?</strong>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default FlashSaleModal;
